<template>
  <div
    ref="modal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modelSingle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <!--begin::Form-->
      <form class="kt-form" @submit="formSubmit">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">อัพโหลดไฟล์ Export จาก Handheld</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="kt-portlet__body">
              <div class="kt-section kt-section--first">
                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>เลขที่ใบงาน:</label>
                      <span class="form-control">{{job.jobNumber}}</span>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>ประเภท:</label>
                      <span class="form-control">{{job.jobTypeName}}</span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>ต้นทาง:</label>
                      <span class="form-control">{{job.originName}}</span>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>ปลายทาง:</label>
                      <span class="form-control">{{job.destinationName}}</span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <span ref="uploadBtnContainer">
                      <button class="btn btn-sm btn-outline-brand" ref="uploadBtn">
                        <i class="fa fa-upload"></i>
                        อัพโหลดไฟล์ Export จาก Handheld
                      </button>
                    </span>
                  </div>
                </div>
                <div class="row mt-3" v-if="uploadErrors">
                  <div class="col-xl-12">
                    <h4 class="text-danger">
                      <i class="fa fa-exclamation-triangle"></i> รายละเอียดข้อผิดพลาด
                    </h4>
                    <span class="text-mute">กรุณาตรวจสอบข้อมูลตามตารางข้างล่าง</span>
                  </div>
                  <div class="col-xl-12">
                    <table class="table table-sm table-striped table-bordered table-hover mt-3">
                      <thead>
                        <tr>
                          <th style="width: 160px;" class="text-center">BARCODE</th>
                          <th class="text-center">ข้อผิดพลาด</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(value, key) in uploadErrors" :key="key">
                          <td class="text-center">{{key}}</td>
                          <td>{{value[0]}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              <i class="fa fa-times"></i> ปิดหน้าต่าง
            </button>
          </div>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import plupload from "plupload";
import Swal from "sweetalert2";

export default {
  data: function() {
    return {
      uuid: "",
      job: {},
      uploader: null,
      uploadErrors: null
    };
  },
  methods: {
    formSubmit: function(e) {
      e.preventDefault();
    },
    commitJob: function(force = false) {
      var self = this;
      // -- Begin Commit Job
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });
      axios
        .post("/Api/Jobs/Commit", {
          jobId: self.job.jobId,
          force: force
        })
        .then(function(response) {
          if (response.data.status) {
            Swal.fire("สำเร็จ", response.data.message, "success");
            self.$parent.reloadDataTable();
            $(self.$el).modal("hide");
          } else {
            let msg = response.data.message;
            if (response.data.errors) {
              msg +=
                "<div class='text-left mt-3'>หากคุณต้องการปิดใบงานนี้ กรุณายืนยันอีกครั้งโดยคลิกปุ่ม <strong>ฉันต้องการปิดใบงานนี้</strong><br /><br />สาเหตุ: <ul>";
              for (var key in response.data.errors) {
                if (response.data.errors.hasOwnProperty(key)) {
                  var err = response.data.errors[key];
                  msg += "<li>" + err[1] + "</li>";
                }
              }
              msg += "</ul></div>";
            }

            Swal.fire({
              title: "เกิดข้อผิดพลาด",
              html: msg,
              type: "error",
              showCancelButton: true,
              confirmButtonText:
                "<i class='fa fa-archive'></i> ฉันต้องการปิดใบงานนี้",
              cancelButtonText: "ตรวจสอบข้อมูล"
            }).then(result => {
              if (result.value) {
                self.commitJob(true);
              }
            });
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
      // -- End Commit Job
    }
  },
  mounted() {
    let self = this;
    self.uuid = self.$uuid.v1();

    $(self.$refs.modal).on("hidden.bs.modal", function() {
      self.uuid = self.$uuid.v1();
      self.job = {};
      self.uploadErrors = null;
    });

    // Init Uploader
    self.uploader = new plupload.Uploader({
      runtimes: "html5",

      browse_button: self.$refs.uploadBtn, // you can pass in id...
      container: self.$refs.uploadBtnContainer, // ... or DOM Element itself

      url: "/Components/Plupload?reference=" + self.uuid,

      max_retries: 5,

      chunk_size: "1mb",

      filters: {
        max_file_size: "10mb",
        mime_types: [{ title: "Text file", extensions: "txt,json" }]
      },

      init: {
        FilesAdded: function(up, files) {
          Swal.fire({
            title: "ระบบกำลังอัพโหลดไฟล์",
            html: "กรุณารอสักครู่...",
            onBeforeOpen: () => {
              Swal.showLoading();
            }
          });

          up.start();
        },

        UploadComplete: function(up, files) {
          // Commit upload files
          axios
            .post("/Api/Jobs/Upload", {
              jobId: self.job.jobId,
              fileName: files[0].name,
              reference: self.uuid
            })
            .then(function(response) {
              if (response.data.status) {
                self.uploadErrors = null;
                Swal.fire({
                  title: "อัพโหลดไฟล์สำเร็จ",
                  html:
                    response.data.message +
                    "<br />คุณต้องการ <strong>ปิดใบงาน</strong> ตอนนี้หรือไม่?",
                  type: "success",
                  showCancelButton: true,
                  confirmButtonText:
                    "<i class='fa fa-archive'></i> ปิดใบงานเดี๋ยวนี้",
                  cancelButtonText: "ไว้คราวหลัง"
                }).then(result => {
                  if (result.value) {
                    self.commitJob();
                  }
                });
              } else {
                self.uploadErrors = response.data.errors;
                Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
              }
            })
            .catch(function(error) {
              self.uploadErrors = error.response.data.errors;
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            });
        },

        Error: function(up, err) {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "File Id " +
              err.file.id +
              " Error #" +
              err.code +
              ": " +
              err.message,
            "error"
          );
        }
      }
    });

    self.uploader.init();
  }
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// App/Components/Job/JobImportBarcodeForm.vue